import { render } from "./baseBadge.vue?vue&type=template&id=1143da1c&scoped=true"
import script from "./baseBadge.vue?vue&type=script&lang=js"
export * from "./baseBadge.vue?vue&type=script&lang=js"

import "./baseBadge.vue?vue&type=style&index=0&id=1143da1c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1143da1c"]])

export default __exports__